import type { UploadTableName } from '@/components/upload/types'
import { type ObjectSchema } from 'yup'

import {
  schema as germinationSchema,
  type GerminationTypes,
} from './germination'

import {
  schema as oilContentSchema,
  transform as oilContentTransform,
  type OilContentTypes,
} from './oilContent'
import {
  schema as proteinContentSchema,
  transform as proteinContentTransform,
  type ProteinContentTypes,
} from './proteinContent'
import {
  schema as seedWeightsSchema,
  transform as seedWeightsTransform,
  type SeedWeightsTypes,
} from './seedWeights'
import {
  schema as storageBehaviourSchema,
  type StorageBehaviourTypes,
} from './storageBehaviour'

export type InputTypes =
  | GerminationTypes['input']
  | OilContentTypes['input']
  | ProteinContentTypes['input']
  | SeedWeightsTypes['input']
  | StorageBehaviourTypes['input']

export type UploadTypes =
  | GerminationTypes['upload']
  | OilContentTypes['upload']
  | ProteinContentTypes['upload']
  | SeedWeightsTypes['upload']
  | StorageBehaviourTypes['upload']

export type UploadWithRefTypes =
  | GerminationTypes['withNewReference']
  | OilContentTypes['withNewReference']
  | ProteinContentTypes['withNewReference']
  | SeedWeightsTypes['withNewReference']
  | StorageBehaviourTypes['withNewReference']

export type EmptyInputTypes =
  | GerminationTypes['emptyInput']
  | OilContentTypes['emptyInput']
  | ProteinContentTypes['emptyInput']
  | SeedWeightsTypes['emptyInput']
  | StorageBehaviourTypes['emptyInput']

type Parsers = Record<UploadTableName, ObjectSchema<InputTypes>>
type Transformer = (input: Partial<InputTypes>) => Partial<UploadWithRefTypes>
type Transformers = Record<UploadTableName, Transformer>

export const parsers: Partial<Parsers> = {
  germination: germinationSchema,
  oil_content: oilContentSchema,
  protein_content: proteinContentSchema,
  seed_weights: seedWeightsSchema,
  storage_behaviour: storageBehaviourSchema,
}

const transformers: Partial<Transformers> = {
  oil_content: oilContentTransform,
  protein_content: proteinContentTransform,
  seed_weights: seedWeightsTransform,
}

export const getTransformer = (tableName: UploadTableName): Transformer => {
  return transformers[tableName]
    ? transformers[tableName]
    : (input: Partial<InputTypes>) => input
}
